import { AxiosError } from 'axios';
import { useQuery, useQueryClient, UseQueryOptions } from 'react-query';

import { client } from '../util/client';
import { Practice, Professional } from '@aldebaran/prisma';

export const usePractice = (
  slug: string | undefined | null,
  options: UseQueryOptions<
    Practice & { users: Professional[] },
    AxiosError
  > = {},
) => {
  const queryClient = useQueryClient();
  return useQuery<Practice & { users: Professional[] }, AxiosError>(
    ['practice', slug],
    async () =>
      client(`/practice/public/${slug}`).then((response) => response?.data),
    {
      enabled: !!slug,
      onSuccess: (practice: Practice & { users: Professional[] }) => {
        practice.users.forEach((professional: Professional) =>
          queryClient.setQueryData(
            ['professional', professional.slug],
            professional,
          ),
        );
        options.onSuccess?.(practice);
      },
      retry: false,
      ...options,
    },
  );
};
